import { render, staticRenderFns } from "./AllCourses.vue?vue&type=template&id=8f2fab8a&scoped=true&"
import script from "./allCourses.js?vue&type=script&lang=js&"
export * from "./allCourses.js?vue&type=script&lang=js&"
import style0 from "./AllCourses.vue?vue&type=style&index=0&id=8f2fab8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2fab8a",
  null
  
)

export default component.exports